import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import type { Answers } from "@/features/forms/models";
import type { UserAttributes } from "@/shared/models";
import type { DateOfBirthValues } from "@/shared/models/legacy-types";

export interface QuestionnaireStore {
  heightFeet?: number;
  heightInches?: number;
  initialWeight?: number;
  expectedWeight?: number;
  dateOfBirth?: DateOfBirthValues;
  gender?: UserAttributes["gender"];
  state?: string;
  intakeFormId?: string;
  intakeAnswers?: Answers;

  setHeight: (height: { heightFeet: number; heightInches: number }) => void;
  setInitialWeight: (initialWeight: number) => void;
  setExpectedWeight: (expectedWeight: number) => void;
  setDateOfBirth: (dateOfBirth: DateOfBirthValues) => void;
  setGender: (gender: UserAttributes["gender"]) => void;
  setState: (state: string) => void;
  setIntake: (intake: { intakeFormId: string; intakeAnswers: Answers }) => void;

  reset: VoidFunction;
}

export const useQuestionnaireStore = create<QuestionnaireStore>()(
  persist(
    (set) => ({
      setHeight: ({ heightFeet, heightInches }) =>
        set({ heightFeet, heightInches }),
      setInitialWeight: (initialWeight) => set({ initialWeight }),
      setExpectedWeight: (expectedWeight) => set({ expectedWeight }),
      setDateOfBirth: (dateOfBirth) => set({ dateOfBirth }),
      setGender: (gender) => set({ gender }),
      setState: (state) => set({ state }),
      setIntake: ({ intakeFormId, intakeAnswers }) =>
        set({ intakeFormId, intakeAnswers }),

      reset: () =>
        set({
          heightFeet: undefined,
          heightInches: undefined,
          initialWeight: undefined,
          expectedWeight: undefined,
          dateOfBirth: undefined,
          gender: undefined,
          state: undefined,
          intakeFormId: undefined,
          intakeAnswers: undefined,
        }),
    }),
    {
      name: "questionnaire-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
